import { ThunkAction, AnyAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { show, hide } from '.';

let clearHideTimeout: () => null | void = () => null;

export const showMessage =
    (text: string, delay: number): ThunkAction<void, RootState, unknown, AnyAction> =>
    async (dispatch) => {
        clearHideTimeout?.();
        await dispatch(show(text));
        const timeoutId = setTimeout(() => {
            dispatch(hide());
            clearHideTimeout = () => null;
        }, delay);
        clearHideTimeout = () => {
            window.clearTimeout(timeoutId);
        };
    };
